import { JSX } from "react";
import SVGClear from "../../icons/Clear.svg?react";
import Icon from "../ui/Icon";
import styles from "./Modal.module.css";

interface Props {
  onClose: () => void;
  children: JSX.Element;
}

const Modal = ({ onClose, children }: Props) => (
  <div className={styles.modal}>
    <div className={styles.overlay} onClick={onClose}></div>
    <div className={styles.content}>
      <button
        type="button"
        onClick={onClose}
        className={styles["clear-button"]}
      >
        <Icon glyph={SVGClear} className={styles["clear-icon"]} />
      </button>
      {children}
    </div>
  </div>
);

export default Modal;
